import {Tag} from "antd";
import {getItemString} from "../../../shared/utils/basic";
import dayjs from "dayjs";
import {Sorter} from "../../../shared/components/Sorter";
import React from "react";

export const getCouponLogColumns = (krTextData, currentUser) => {
    return [
        {
            title: '쿠폰 마스터 ID',
            dataIndex: 'coupon',
            key: 'coupon',
        },
        {
            title: '쿠폰 ID',
            dataIndex: 'couponId',
            key: 'couponId',
        },
        {
            title: '쿠폰 타입',
            dataIndex: 'type',
            key: 'type',
            render: (type) => {
                const couponTypes = [
                    {
                        color: 'green',
                        text: '공용 쿠폰',
                    },
                    {
                        color: 'blue',
                        text: '개별 쿠폰'
                    }
                ];
                return <Tag color={couponTypes[type].color}>{couponTypes[type].text}</Tag>;
            },
        },
        {
            title: '보상',
            dataIndex: 'items',
            width: '30%',
            render: (items) => getItemString(krTextData[currentUser.target] ,items)
        },
        {
            title: '사용일',
            dataIndex: 'lastupdate',
            width: '20%',
            render: (value) => dayjs.unix(value).format('YYYY-MM-DD HH:mm:ss'),
            sorter: (a, b) =>  Sorter.DATE(a.lastupdate, b.lastupdate),
        },
    ]
}